module.exports = "<div class=\"cardup\">\n        <i class=\"glyphicon glyphicon-search\"></i>\n    </div>\n<div id=\"mainWindowSearch\" class=\"cardon\">\n    <form>\n        <div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search\">\n            <div class=\"input-group-btn\">\n            </div>\n        </div>\n    </form>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowSearch.component.html
// module id = 1173
// module chunks = 2